export default __webpack_public_path__ + "static/media/at.wallet.ba2fe751.jpeg";